const currenciesData = [
  { value: 'BTC', label: 'Bitcoin' },
  { value: 'ETH', label: 'Ethereum' },
  { value: 'TRX', label: 'Tron' },
  { value: 'LTC', label: 'Litecoin' }
];

export default currenciesData;
